"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QiHuoSmallTable = void 0;
var react_1 = __importDefault(require("react"));
require("./index.less");
var lodash_1 = require("lodash");
var web_1 = require("../../modules/qihuo/web");
var swr_1 = __importDefault(require("swr"));
var custom_table_1 = require("./custom_table");
/**
 * 期货小表格
 * @returns
 */
function QiHuoSmallTable(props) {
    var _a, _b, _c;
    var tableitem = (0, lodash_1.cloneDeep)(custom_table_1.custom_qhtable[props.table_key]);
    var mt = (_a = props.mt) !== null && _a !== void 0 ? _a : 0;
    var pageindex = 1;
    var count = (_b = props.count) !== null && _b !== void 0 ? _b : 5;
    var order = (_c = props.order) !== null && _c !== void 0 ? _c : 'desc';
    //期货字段
    var qihuoitemlist = tableitem.filter(function (v) {
        return typeof v.value == 'number';
    }).map(function (v) { return v.value; });
    var _d = (0, swr_1.default)("qihuomiddle_".concat(props.blockName, "_").concat(props.fs, "_").concat(props.table_key, "_").concat(props.order, "_").concat(props.orderdur), function () { return (0, web_1.searchQiHuoListWithBlock)(qihuoitemlist, pageindex, count, props.orderdur, order, props.blockName); }, {
        refreshInterval: 60 * 1000,
        dedupingInterval: 59 * 1000
    }), data = _d.data, error = _d.error;
    if (!data)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "quotetable", style: mt > 0 ? { marginTop: mt } : {} },
        react_1.default.createElement("table", null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, tableitem.filter(function (v) { return v.hide != true; }).map(function (v, index) {
                    return react_1.default.createElement("th", { key: index, dangerouslySetInnerHTML: { __html: v.title || "" } });
                }))),
            react_1.default.createElement("tbody", null, !!(data === null || data === void 0 ? void 0 : data.result) && (data === null || data === void 0 ? void 0 : data.result.map(function (v, index) {
                return react_1.default.createElement("tr", { key: index }, tableitem.filter(function (v) { return v.hide != true; }).map(function (v2, index2) {
                    return react_1.default.createElement("td", { key: index2, className: v2.tdclass ? v2.tdclass : '' },
                        v2.value == 'rank' &&
                            react_1.default.createElement(react_1.default.Fragment, null, index + 1),
                        typeof v2.value == 'number' && v[v2.value].html);
                }));
            }))))));
}
exports.QiHuoSmallTable = QiHuoSmallTable;
